import * as React from "react";
import type { SVGProps } from "react";
export const SvgArrowRefresh = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M3.641 2.955a6.667 6.667 0 0 1 9.818 8.872L11.333 8h2a5.333 5.333 0 0 0-9.027-3.848l-.665-1.197Zm8.717 10.09A6.667 6.667 0 0 1 2.54 4.173L4.666 8h-2a5.333 5.333 0 0 0 9.027 3.847l.665 1.198Z"
    />
  </svg>
);
